const MyNetwork = () => {
    return (
        <div>
            <h1>My Network</h1>
        </div>
    );
};

export default MyNetwork;
